<template>
    <nav id="sidebar" :class="{ open: menu.isOpen }">
        <header class="" @click="toggleMenu(false)">
            <h1 v-if="menu.isOpen">SUPSIS</h1>
            <Arrows :is-animated="true" id="arrow-icon" :class="{ open: menu.isOpen }" data-v-step="2" />
        </header>

        <ul
            v-if="permissions.length || isAdmin"
            :key="'menu-' + forceRenderCount"
            ref="scrollRef"
            class="list-unstyled"
        >
            <li v-for="(item, index) in allowedRoutes()" :key="index">
                <router-link v-if="item.children === undefined || item.children.length === 0" :to="item.path">
                    <a-tooltip :title="item.title" placement="right" @click="clickItem(item)">
                        <div class="d-flex align-items-center">
                            <!--                            <md-icon-->
                            <!--                                class="m-0 mr-1 whatsapp-icon"-->
                            <!--                                v-if="item.icon === 'whatsapp'"-->
                            <!--                                style="color: #06e576"-->
                            <!--                            >-->
                            <!--                                whatsapp-->
                            <!--                            </md-icon>-->
                            <!--                            instegram özellliği düzeltildiği zaman burayı aç-->
                            <!--                            <div class="instagram-icon" v-else-if="item.icon === 'instagram'>-->
                            <!--                                <InstagramIcon />-->
                            <!--                            </div>-->

                            <div>
                                <a-icon
                                    :type="item.antIcon"
                                    v-if="item.antIcon"
                                    style="font-size: 20px"
                                    :style="{ color: bugExist ? 'red !important' : '#9ba2b6 !important' }"
                                />
                                <component
                                    v-bind:is="item.icon"
                                    class="myIcon"
                                    :style="{
                                        fill:
                                            item.icon === 'ticket' && getWaitingTickets.length > 0
                                                ? '#d5295c !important'
                                                : 'inherit',
                                    }"
                                    v-else
                                />
                            </div>

                            <span>{{ item.title }}</span>
                        </div>
                    </a-tooltip>
                </router-link>

                <a-tooltip :title="item.title" placement="right">
                    <a
                        v-if="item.children !== undefined && item.children.length"
                        class="pointer-event"
                        @click="toggleShowChildren(item.path)"
                    >
                        <component v-bind:is="item.icon" class="myIcon" />
                        <span>{{ item.title }}</span>
                    </a>
                </a-tooltip>
                <ul
                    v-if="item.children !== undefined && item.children.length && item.showChildren === true"
                    class="list-unstyled"
                >
                    <li v-for="(item2, index2) in item.children" :key="index2">
                        <router-link :to="item2.path">
                            <a-tooltip :title="item2.title" placement="right" @click="toggleMenu(true)">
                                <div>
                                    <component v-bind:is="item2.icon" class="myIcon" />
                                    <span>{{ item2.title }}</span>
                                </div>
                            </a-tooltip>
                        </router-link>
                    </li>
                </ul>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import menu, { toggleShowChildren } from "../utils/menu";
import Comments from "./svg/Comment";
import History from "./svg/History";
import Visitor from "./svg/Visitor";
import Masks from "./svg/Masks";
import Users from "./svg/User";
import Trigger from "./svg/Trigger";
import Integrations from "./svg/Integrations";
import UserSlash from "./svg/UserSlash";
import ClipboardList from "./svg/ClipboardList";
import BoxOpen from "./svg/BoxOpen";
import HandPaper from "./svg/HandPaper";
import Ban from "./svg/Ban";
import Arrows from "./svg/Arrows";
import Cogs from "./svg/Cogs";
import Bug from "./svg/Bug";
import WindowOpen from "./svg/WindowOpen";
import Calendar from "./svg/Calendar";
import Location from "./svg/Location";
import ClusterDashboard from "./svg/ClusterDashboard";
import Site from "./svg/Site";
import { log2 } from "../utils/log2";
import OfflineSupport from "./svg/OfflineSupport";
import DetailReports from "./svg/DetailReports";
import Catalog from "./svg/Catalog";
import Chatbot from "./svg/Chatbot";
import Ticket from "./svg/Ticket";
import Integration from "./svg/Integration";
import CreditCard from "./svg/CreditCard";
import { getPersistenceData } from "../utils/persistenceStorage";
import { SELF_SERVICE_DOMAIN } from "../utils/utils";
import Apps from "./svg/Apps";
import Tags from "./svg/Tags";
import systemPubSub from "../utils/systemPubSub";
import { filter } from "rxjs/operators";
import InstagramIcon from "./svg/InstagramIcon";
import Coupon from "./svg/Coupon";

const log = log2("Sidebar");
export default {
    name: "Sidebar",
    components: {
        Coupon,
        InstagramIcon,
        Integration,
        Apps,
        Comments,
        Chatbot,
        History,
        Masks,
        Users,
        Visitor,
        UserSlash,
        ClipboardList,
        BoxOpen,
        HandPaper,
        Ban,
        Cogs,
        Bug,
        WindowOpen,
        Calendar,
        OfflineSupport,
        DetailReports,
        Catalog,
        ClusterDashboard,
        Site,
        Ticket,
        CreditCard,
        Arrows,
        Trigger,
        Tags,
        Integrations,
    },
    data() {
        return {
            forceRenderCount: 0,
            timerId: null,
            timerId2: null,
            debugMode: SELF_SERVICE_DOMAIN === location.hostname,
            unSubs: [],
        };
    },

    mounted() {
        this.timerId = setInterval(() => {
            if (!this.permissions.length && this.isLoggedIn) {
                this.getPermissions({ perPage: 500, page: 1 });
            }
            if (this.permissions.length && this.timerId) {
                clearInterval(this.timerId);
            }
        }, 5000);
        if (this.ticketViewPermissionExists) {
            this.fetchWaitingTickets({
                page: 1,
                perPage: !isNaN(getPersistenceData("ticket-page-size") || "undefined")
                    ? parseInt(getPersistenceData("ticket-page-size"))
                    : 10,
                tag: "all",
            });
            const newTicketSub = systemPubSub.stream.pipe(filter((x) => x.type === "ticket_message")).subscribe((x) => {
                this.fetchWaitingTickets({
                    page: 1,
                    perPage: !isNaN(getPersistenceData("ticket-page-size") || "undefined")
                        ? parseInt(getPersistenceData("ticket-page-size"))
                        : 10,
                    tag: "all",
                });
            });
            this.unSubs.push(() => newTicketSub.unsubscribe());
        }
    },
    computed: {
        ...mapState({
            menu: (state) => state.layout.menu,
            user: (state) => state.auth.user,
            bugExist: (state) => state.auth.bugExist,
            adminUser: (state) => state.auth.adminUser,
            isAdmin: (state) => state.auth.adminUser != null,
            permissions: (state) => state.permission.permissions,
            ticketViewPermissionExists: (state) => {
                const isRoot = _.get(state.auth.user, "role.isRoot");
                return (
                    isRoot ||
                    !!(_.get(state.auth.user, "role.permissions") || []).find(
                        (x) => x.name === "offlineSupportRequest.get"
                    )
                );
            },
        }),
        ...mapGetters({
            isLoggedIn: "auth/isLoggedIn",
            getWaitingTickets: "ticket/getWaitingTickets",
        }),
    },
    methods: {
        ...mapActions({
            toggleMenu: "layout/toggleMenu",
            getPermissions: "permission/getPermissions",
            fetchWaitingTickets: "ticket/fetchWaitingTickets",
        }),
        clickItem(item) {
            this.toggleMenu(true);
            if (item.title === "ChatBot") {
                document.querySelector(".btnCloseCb")?.click();
            }
        },
        allowedRoutes() {
            let items = this.getSideBarItems();

            if (this.adminUser) {
                items = items.filter((item) => {
                    if (this.adminUser.isFullAccess) return true;
                    else if (item.superAdminPageKey)
                        return (this.adminUser.approvedPages || []).map((x) => x.page).includes(item.superAdminPageKey);
                    else {
                        return true;
                    }
                });
                return items;
            }
            if (this.user.role.isRoot) {
                return items.filter((c) => !c.isAdmin);
            }
            try {
                log("perms", {
                    items: items.map((x) => x.permission),
                    userRoles: this.user.role.permissions.map((x) => x.name),
                });
                return items.filter(
                    (menuItem) =>
                        !menuItem.isAdmin &&
                        !!this.user.role.permissions.find((userPermission) => {
                            if (!menuItem.permission) return true;
                            if (Array.isArray(menuItem.permission)) {
                                if (menuItem.permission.includes(userPermission.name)) {
                                    return true;
                                }
                            }
                            if (userPermission !== null && userPermission.name === menuItem.permission) {
                                return true;
                            }
                        })
                );
            } catch (e) {
                console.error(
                    "Some permission with a name could not found! Compare menu items and stored permission keys.",
                    e
                );
            }
        },
        toggleShowChildren(path) {
            log("toggleShowChildren called", path);
            toggleShowChildren(path);
            this.forceRenderCount += 1;
            setTimeout(() => {
                this.$refs.scrollRef.scrollTop = 99999;
            }, 100);
        },
        getSideBarItems() {
            return menu(this).filter((x) => x.enabled);
        },
        menuClick(item) {},
    },
    beforeDestroy() {
        this.unSubs.forEach((sub) => sub());
        if (this.timerId) clearInterval(this.timerId);
        if (this.timerId2) clearInterval(this.timerId2);
    },
};
</script>

<style lang="scss" scoped>
#sidebar {
    //overflow: hidden;
}

#sidebar > ul {
    cursor: pointer;
}

#sidebar > ul > li > ul {
    margin-top: 9px;

    li {
        margin: 4px 0 6px 6px;
    }
}

.myIcon {
    width: 22px;
    height: 22px;
}

.new-theme {
    #sidebar {
        background-color: #1e1e2d;
        border-right: none;

        &.open header {
            padding: 0 30px;
            justify-content: space-between;
        }

        header {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;
            height: 65px;
            cursor: pointer;

            #arrow-icon {
                transition: all 0.3s;
                transform: rotateY(180deg);

                &.open {
                    transform: rotateY(0deg);
                }
            }

            h1 {
                font-family: "Poppins";
                font-weight: bold;
                font-size: 18px;
                color: #ffffff;
                margin: 0;
                user-select: none;
            }
        }

        ul li a {
            color: #a2a3b7;
            font-family: "Poppins";
            font-size: 13px;

            &.router-link-exact-active.router-link-active {
                color: #ffffff;
            }
        }

        .instagram-icon {
            svg {
                width: 26px !important;
                height: 26px !important;
                border-radius: 4px !important;
                background: radial-gradient(
                    circle at 30% 107%,
                    #fdf497 0%,
                    #fdf497 5%,
                    #fd5949 45%,
                    #d6249f 60%,
                    #285aeb 90%
                ) !important;
            }
        }
    }
}
</style>
<style lang="scss">
.ant-tooltip-content {
    margin-left: 20px;
}
</style>
